import {BaseModel} from "../base";
import {bbTimeZone} from '../../utils/time_zone';

class OpeningHoursModel extends BaseModel {

    constructor(data) {
        super(data);
    }

    getDay(day) {
        return _.findWhere(this.openingHoursSpecification, {dayOfWeek: 'http://schema.org/' + day});
    }

    openTimes() {
        return _.map(this.openingHoursSpecification, day => day.opens);
    }

    earliestOpening() {
        return _.first(this.openTimes().sort());
    }

    closeTimes() {
        return _.map(this.openingHoursSpecification, day => day.closes);
    }

    latestClosing() {
        return _.last(this.closeTimes().sort());
    }

    shiftToDay(day) {
        const dayIndex = this.openingHoursSpecification.findIndex(oh => oh.dayOfWeek.includes(day)) || 0;
        const ohSpecs = Object.assign([], this.openingHoursSpecification);
        this.openingHoursSpecification = ohSpecs.splice(dayIndex).concat(ohSpecs);
    }

    getFormattedOpenTimes(highlightCurrentDay = true) {
        const ohSpecs = Object.assign([], this.openingHoursSpecification);
        return ohSpecs.map((openingHoursObject) => {
            const day = openingHoursObject.dayOfWeek.substring(openingHoursObject.dayOfWeek.lastIndexOf('/') + 1, openingHoursObject.dayOfWeek.length);
            return {
                /*
                * Times are returned in this format 18:00:00, so we have to
                * mock a day in order to use moment for pretty format it
                *
                * Days are also returned in English (en-GB) so in order to get the current day
                * we have to explicitly set the locale.
                */
                isToday: highlightCurrentDay && (moment().locale('en-GB').format('dddd').toLowerCase() === day.toLowerCase()),
                opens: openingHoursObject.opens ? moment(`1970-01-01T${openingHoursObject.opens}`).formattedTime() : null,
                closes: openingHoursObject.closes ? moment(`1970-01-01T${openingHoursObject.closes}`).formattedTime() : null,
                day
            };
        });
    }

    getOpenTimesWithFormat(highlightCurrentDay = true, timeFormat = 'h:mma') {
      return this.openingHoursSpecification.map((openingHoursObject) => {
          const day = openingHoursObject.dayOfWeek.substring(openingHoursObject.dayOfWeek.lastIndexOf('/') + 1, openingHoursObject.dayOfWeek.length);
          const opens = openingHoursObject.opens;
          const closes = openingHoursObject.closes;
          const currentDateString = moment().format('YYYY-MM-DD');

          return {
              /*
              * Times are returned in this format 18:00:00, so we have to
              * mock a day in order to use moment for pretty format it
              *
              * Days are also returned in English (en-GB) so in order to get the current day
              * we have to explicitly set the locale.
              */
              isToday: highlightCurrentDay && (moment().locale('en-GB').format('dddd').toLowerCase() === day.toLowerCase()),
              opens: opens ? bbTimeZone.convertToDisplay( moment(`${currentDateString}T${opens}`)).format(timeFormat) : null,
              closes: closes ? bbTimeZone.convertToDisplay(moment(`${currentDateString}T${closes}`)).format(timeFormat) : null,
              day
          };
      });
    }
}

export {
    OpeningHoursModel
};
